module.exports = __webpack_public_path__ + "img/app.0ca79260.png";